<template>
  <div class="reset-password-view">
    <div class="form-side">
      <div class="reset-password-pane">
        <div class="logo">
          <img
            alt="Fuell logo"
            :src="require('@/assets/img/logo.svg')"
          >
        </div>
        <div v-if="!isCheckingTokenFlag">
          <template v-if="!tokenIsInvalidErrorFlag && !notAuthorizedErrorFlag">
            <reset-passcode-form />
          </template>
          <template v-else>
            <div class="d-flex flex-column justify-content-between mt-3">
              <span
                class="Fuell-Text"
                v-t="{path:'login_change_passcode_invalid_token_error'}"
              ></span>
              <div class="d-flex justify-content-between w-100 my-3">

                <button
                  class="Fuell-Button block blue"
                  @click="openSupport"
                  v-t="{path:'snackbar_launch_intercom_message'}"
                ></button>
              </div>

            </div>
          </template>
        </div>
        <div
          class="w-100 d-flex justify-content-center"
          v-else
        >
          <spinner />
        </div>
        <div
          class="w-100 d-flex justify-content-center mt-3"
          v-if="!isCheckingTokenFlag"
        >
          <small
            v-if="userLogged"
            class="login-form--forgot-password"
            role="button"
            @click="goToDashboard"
            v-t="{path:'login_change_passcode_action_return_to_dashboard'}"
          ></small>
          <small
            v-else
            class="login-form--forgot-password"
            role="button"
            @click="goToLogin"
            v-t="{path:'user_accept_invitation_redirect_login'}"
          ></small>

        </div>

      </div>
    </div>
    <div class="image-side"></div>
  </div>
</template>

<script>
import ResetPasscodeForm from '../_components/ResetPasscodeForm'
import Spinner from '@/components/Commons/Spinner'
import usersApi from '@/modules/users/_api'
export default {
  name: 'ResetPasscode',
  components: { ResetPasscodeForm, Spinner },
  data () {
    return {
      tokenIsInvalidErrorFlag: false,
      isCheckingTokenFlag: false,
      notAuthorizedErrorFlag: false

    }
  },
  computed: {
    resetToken () {
      return this.$route.params.token
    },
    userLogged () {
      return this.$store.getters['LoginStore/loggedUserId'] || false
    }
  },
  methods: {
    async openSupport () {
      let errorMessage = ''
      errorMessage = this.$t('login_change_passcode_invalid_token_error')
      const defaultMessage = this.$route && this.$route.path ? this.$t('intercom_predefined_error_message_with_route', { errorMessage: errorMessage, routerUrl: this.$route.path }) : this.$·this.$t('intercom_predefined_error_message', { errorMessage: errorMessage })
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(defaultMessage)
      }
    },
    goToDashboard () {
      this.$router.push({ name: 'dashboard' })
    },
    goToLogin () {
      this.$router.push({ name: 'signin' })
    },
    async checkPasscodeToken () {
      try {
        if (this.isCheckingTokenFlag) return
        this.isCheckingTokenFlag = true
        await usersApi.getUserByPasscodeToken(this.resetToken)
      } catch (error) {
        if (error.response.status === 406) {
          this.tokenIsInvalidErrorFlag = true
          this.notAuthorizedErrorFlag = false
        }

        if (error.response.status === 401) {
          this.tokenIsInvalidErrorFlag = false
          this.notAuthorizedErrorFlag = true
        }
      } finally {
        this.isCheckingTokenFlag = false
      }
    }
  },
  async created () {
    await this.checkPasscodeToken()
  }
}
</script>
<style scoped>
.reset-password-logo {
  cursor: pointer;
}
</style>

<style scoped>
.login-form--forgot-password {
  cursor: pointer;
  width: auto;
  font-weight: 300;
  color: var(--blue-action-1-active);
  font-size: 12px;
  letter-spacing: -0.26px;
  margin-top: -6px;
}

.reset-password-view {
  display: flex;
  height: 100vh;
}

.reset-password-view .form-side {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.reset-password-view .image-side {
  display: none;
}

.reset-password-view .form-side .reset-password-pane {
  max-width: 375px;
  width: 100%;
  padding: 0 25px;
}

.reset-password-view .form-side .reset-password-pane .logo {
  margin-bottom: 47px;
  text-align: center;
}

/* Desktop breakpoint */
@media only screen and (min-width: 768px) {
  .reset-password-view .form-side {
    width: 50%;
  }

  .reset-password-view .image-side {
    width: 50%;
    display: block;
    background-image: url("~@/assets/img/login-landing-image.jpg");
    background-position: center center;
    background-size: cover;
  }
}
</style>
